// extracted by mini-css-extract-plugin
export default {"segunda-seccion":"estilos_segunda-seccion__8pM5B","marca-agua":"estilos_marca-agua__RdNR4","texto":"estilos_texto__T-ue3"};